<script lang="ts">
  import { push, location } from "svelte-spa-router";
  import NavbarItem from "../molecules/NavbarItem.svelte";
  import NavbarAccordion from "../molecules/NavbarAccordion.svelte";
  import Icon from "../molecules/Icon.svelte";
	import { routeNames, masters, settings, recruitments } from "../routes";
</script>

<nav class="sidebar bg-gray-50">
	<ul class="p-4">
		<NavbarItem click={()=> push('/home')} selected={$location === '/home'}>
			<Icon name="home" title="ホーム"/>
		</NavbarItem>

		<NavbarAccordion>
			<Icon name="clipboardList" title="求人管理"/>
			<div slot="items">
				{#each recruitments as route}
					<NavbarItem level={1} click={() => push(route.path)} selected={$location === route.path}>
						<Icon name={route.icon} title="{route.label}" />
					</NavbarItem>
				{/each}
			</div>
		</NavbarAccordion>

		{#if false }
		  <NavbarItem click={()=> push('/inquiries')} selected={$location === '/inquiries'}>
		  	<Icon name="mail" title="お問い合わせ"/>
		  </NavbarItem>
		{/if}

		<NavbarAccordion>
			<Icon name="database" title="マスター管理" />
			<div slot="items">
				{#each masters as route}
					<NavbarItem level={1} click={() => push(route.path)} selected={$location === route.path}>
						<Icon name={route.icon} title="{route.label}" />
					</NavbarItem>
				{/each}
			</div>
		</NavbarAccordion>

		<NavbarAccordion>
			<Icon name="cog" title="設定"/>
			<div slot="items">
				{#each settings as route}
					<NavbarItem level={1} click={() => push(route.path)} selected={$location === route.path}>
						<Icon name={route.icon} title="{route.label}" />
					</NavbarItem>
				{/each}
			</div>
		</NavbarAccordion>

		<NavbarItem click={()=> {
			window.localStorage.removeItem('token')
			push('/login')
		}} divider>
			<Icon name="logout" title="ログアウト" />
		</NavbarItem>
	</ul>
</nav>

<style>
	.sidebar {
		min-height: calc(100vh - 60px);
		width: 235px;
		flex-shrink: 0;
	}
</style>